import { useEffect, useState } from 'react';
import { usePolicyStore } from '@/dashboard/store/PolicyStore';
import { JoveProjectTypeEnum } from '@jove-frontend/enums';
import { PROVIDER_SOURCE, PROVIDER_SOURCE_LIST, formatCurrency, handleQuotePriceDateInfo, useQuotePriceDetailInfo } from '@jove-frontend/uikit';
import { AssuredWorkload, DirectionsTransit, Workspaces } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { cloneDeep, isArray } from 'lodash';

const PaymentSummaryView = () => {
  const [{ paymentScheduleInfo, policies }] = usePolicyStore((store) => [store.state]);
  const [productList, setProductList] = useState([]);
  const [priceTotalInfo, setPriceTotalInfo] = useState(null);
  const { generateQuotePriceSummaryInfoList, generateQuotePriceSummaryTotalInfoList } = useQuotePriceDetailInfo();

  useEffect(() => {
    if (paymentScheduleInfo) {
      const { policies, total } = paymentScheduleInfo?.payment_summary || {};
      const dataList = [];
      cloneDeep(policies || []).forEach((item) => {
        const handleItem = handleQuotePriceDateInfo(item);
        const coverageList = generateQuotePriceSummaryInfoList(handleItem);
        coverageList.forEach((item) => {
          item.content = item.coverageText;
        });
        handleItem.ready_to_pricing = true;
        const totalPriceList = generateQuotePriceSummaryTotalInfoList(handleItem, { projectSource: JoveProjectTypeEnum.dashboard });
        dataList.push({
          title: PROVIDER_SOURCE_LIST().find((aItem) => aItem.value === handleItem.provider_code)?.label,
          titleDisplayType: [
            PROVIDER_SOURCE().ACCELERANT.value,
            PROVIDER_SOURCE().ACCELERANT_GIT.value,
            PROVIDER_SOURCE().RECRUITMENT.value,
          ].includes(handleItem.provider_code)
            ? 1
            : [PROVIDER_SOURCE().ACCELERANT.value, PROVIDER_SOURCE().ACCELERANT_GIT.value].includes(handleItem.provider_code)
            ? 2
            : 3,
          list: [...coverageList, ...totalPriceList],
        });
      });

      setProductList(dataList);
      setPriceTotalInfo(total);
    }
  }, [paymentScheduleInfo]);

  if (!isArray(policies) || policies.length === 0) {
    return null;
  }

  return (
    <Box className="flex flex-col space-y-7 rounded-md bg-neutral-100 p-6">
      <Typography variant="h5" className="font-black">
        Payment Summary
      </Typography>
      <Box className="flex flex-col">
        <Typography variant="subtitle1" className="font-bold">
          Your Policy Summary
        </Typography>
        <Box className="flex flex-col space-y-2">
          {productList.map((item, index) => {
            return (
              <Box key={index} className="flex flex-col overflow-hidden rounded-lg bg-white">
                <Box
                  className="flex flex-row items-center space-x-2 px-4 py-2 text-white"
                  sx={{ backgroundColor: item.titleDisplayType === 1 ? '#4285F4' : item.titleDisplayType === 2 ? '#1CB258' : '#2DC18E' }}
                >
                  {item.titleDisplayType === 1 && <AssuredWorkload />}
                  {item.titleDisplayType === 2 && <DirectionsTransit />}
                  {item.titleDisplayType === 3 && <Workspaces />}
                  <Typography variant="subtitle1" className="text-lg font-bold">
                    {item.title}
                  </Typography>
                </Box>
                <Box className="flex flex-col space-y-1 px-4 py-2">
                  {item.list.map((aItem, aIndex) => {
                    return (
                      <Box key={aIndex} className="flex flex-row justify-between">
                        <Typography variant="subtitle1" className="font-medium">
                          {aItem.title}
                        </Typography>
                        <Typography variant="subtitle1" className="font-bold">
                          {aItem.content}
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
      {!!priceTotalInfo && (
        <Box className="flex flex-col">
          <Typography variant="subtitle1" className="font-bold">
            Total Annual Payment
          </Typography>
          <Box className="bg-light-blue flex flex-row justify-between rounded-lg px-3 py-2">
            <Typography variant="h6" className="font-black">
              Annual total
            </Typography>
            <Typography variant="h6" className="font-black">
              {formatCurrency({ amount: priceTotalInfo?.total_amount, currency: priceTotalInfo?.currency })}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default PaymentSummaryView;
